import { render } from "./PodcastList.vue?vue&type=template&id=001c08c8&scoped=true"
import script from "./PodcastList.vue?vue&type=script&lang=js"
export * from "./PodcastList.vue?vue&type=script&lang=js"

import "./PodcastList.vue?vue&type=style&index=0&id=001c08c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001c08c8"]])

export default __exports__